module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "PainterList"
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('el-card', {
    attrs: {
      "id": "list"
    }
  }, [_c('div', {
    staticClass: "menu-wrap"
  }, [_vm._l((_vm.menuInfo2), function(item, index) {
    return _c('div', {
      staticClass: "icon-menu",
      on: {
        "click": function($event) {
          _vm.clickMenu(index)
        }
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n              " + _vm._s(_vm.$t(item.title)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "img-wrap",
      style: ({
        'background-color': item.bkColor
      })
    }, [_c('div', {
      staticClass: "top"
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.imgUrl
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "Hcp-footer"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": _vm.contactURL
    }
  }, [_vm._v(_vm._s(_vm.$t('contact us')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.privacyURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Privacy Policy')) + " ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.termsOfUseURL
    }
  }, [_vm._v("|  " + _vm._s(_vm.$t('Terms of Use')) + " | ")]), _vm._v("\n\n          " + _vm._s(_vm.$t('copyright')) + " "), _c('br'), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v(" 沪ICP备08013753号-3  ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "src": "/static/beian.png"
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isZh),
      expression: "isZh"
    }],
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"
    }
  }, [_vm._v(" 沪公网安备 31011502014155号 ")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78a42114"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HcpMenu.vue
// module id = 1483
// module chunks = 7